import { Component, OnInit, Input } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Iaddress } from 'my-lib-sanfelici/my-lib-sanfelici';

@Component({
  selector: 'app-address-edit',
  templateUrl: './address-edit.component.html',
  styleUrls: ['./address-edit.component.css']
})
export class AddressEditComponent implements OnInit {
@Input() address: Iaddress;
  constructor(private db: AngularFirestore) { }

  ngOnInit() {
if (this.address){
  
} else {
  this.address = {country: null,
  route: null,
postal_code: null,
administrative_area_level_1: null,
administrative_area_level_2: null,
administrative_area_level_3: null,
street_number: null,
latitude: null, longitude: null
}
}
  }

}
